import React, {useState} from 'react';
import {connect} from "react-redux";
import {
  BACKSPLASH_LABELS,
  MEASURE_UNITS,
  SIDEBAR_NAVIGATION_BUTTONS,
  SQFT_BACKSPLASH_TYPES,
  SQFT_BACKSPLASH_TYPES_METRIC,
  SQFT_WALL_TYPES
} from "../../../../../constants";
import SqftNavBacksplashesFeature from "./SqftNavBacksplashesFeature";
import config from "../../../../canvas/store/sqftConfig";
import SqftNavBacksplashesCustomButton from "./toolBacksplash/SqftNavBacksplashesCustomButton";
import SqftNavBacksplashesFreeDrawButton from "./toolBacksplash/SqftNavBacksplashesFreeDrawButton";
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../../../../../actions/sqftMenuFunctions";
import SQFTFeaturesHeader from "../../cabinet/toolMenu/commonParts/SQFTFeaturesHeader";
import {getFeatureGroupByPartIds} from "../../../../../helpers/shapeHelper";

const SqftNavBacksplashes = (props) => {
  const { menuOpened } = props;
  const [selectedBacksplash, setSelectedBacksplash] = useState(0);
  const expanded = menuOpened === SIDEBAR_NAVIGATION_BUTTONS.backsplash;
  const backsplashOptions = config.measureUnit === MEASURE_UNITS.Imperial
    ? SQFT_BACKSPLASH_TYPES.concat(SQFT_WALL_TYPES)
    : SQFT_BACKSPLASH_TYPES_METRIC.concat(SQFT_WALL_TYPES)
  const featureGroup = getFeatureGroupByPartIds(Object.keys(BACKSPLASH_LABELS));

  return (
    <div className={"content content--left side-level2" + (expanded ? " expanded" : "")} data-content="backsplash" id="backsplash-overlay">
      <div className="content-inner">
        <SQFTFeaturesHeader headerTitle={""}
                            showSearch={false}
                            showViewTypeSwitcher={false}
                            partId={featureGroup?.partId} />
        <ul className="lightbox-options-wrapper">
          {backsplashOptions.map((navItem, index) =>
            <SqftNavBacksplashesFeature
              key={index}
              featureName={navItem}
              selectedBacksplash={selectedBacksplash}
              setSelectedBacksplash={setSelectedBacksplash}/>
            )
          }
          {
            <SqftNavBacksplashesCustomButton selectedBacksplash={selectedBacksplash}
                                             setSelectedBacksplash={setSelectedBacksplash}/>
          }
          {
            <SqftNavBacksplashesFreeDrawButton selectedBacksplash={selectedBacksplash}
                                               setSelectedBacksplash={setSelectedBacksplash}/>
          }
        </ul>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {menuOpened} = store.sqftMenuState;
  return {
    menuOpened
  };
};

const mapDispatchToProps = {
  setSQFTActiveButton,
  setSQFTMenuOpened
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftNavBacksplashes);
